import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import MyPartyResponse from "./responses/apiResponses";
import { handleAxiosError } from "./responses/AxiosResponseHandler";

class AcceptOfferApi {
    private authClient: AuthClient;

    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async acceptOffer(offerId: string) {

        try {
            const authenticationResponse = this.authClient.getAuthenticationResponse();
            if (authenticationResponse === undefined) {
                return;
            }

            const response = await axios.post(
                `${this.authClient.getApiRoot()}/offers/${offerId}/accept`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
                data: response.data as MyPartyResponse[],
            };

        } catch (error) {
            const errorResponse = handleAxiosError<MyPartyResponse[]>(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
                data: errorResponse.data
            }
        }
    }
}

export default AcceptOfferApi;
